import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import frTranslations from './locales/fr.json';
import arTranslations from './locales/ar.json';

// Récupérer la langue stockée ou utiliser français par défaut
const defaultLanguage = localStorage.getItem('language') || 'fr';


i18n
  .use(initReactI18next)
  .init({
    resources: {
      fr: { translation: frTranslations },
      ar: { translation: arTranslations },
    },
    lng: defaultLanguage, // langue par défaut
    fallbackLng: 'fr',
    interpolation: {
      escapeValue: false,
    },
  });

// Add direction support
i18n.dir = (lng) => {
  const language = lng || i18n.language;
  return language === 'ar' ? 'rtl' : 'ltr';
};

// Update HTML dir attribute when language changes and save to localStorage
i18n.on('languageChanged', (lng) => {
  document.documentElement.dir = i18n.dir(lng);
  document.documentElement.lang = lng;
  // Sauvegarder la langue dans localStorage pour la persistance
  localStorage.setItem('language', lng);
});

// Set initial direction
document.documentElement.dir = i18n.dir();
document.documentElement.lang = i18n.language;

export default i18n;